import React from 'react';

import {
  MlpSkeletonWrapper,
  StyledBoxeswrapper,
  SyledLogoWrapper,
} from './styled';

import { SkeletonBoxes } from './skeleton-boxes/SkeletonBoxes';
import { useFeatureAppContent } from '../../../hooks/use-feature-app-content';
import { useTranslations } from '../../../hooks/use-translations';
import SalesEventMlpLogo from '../sales-event-mlp-logo';
import { Breakpoints, useIsMobile } from '@vw-marketing/us-components';

export const SalesEventMLPSkeleton = () => {
  const isMobile: boolean = useIsMobile(Breakpoints.b960);
  const translations = useTranslations().salesEventMlp;
  const { sales_event_logo_url_light } = useFeatureAppContent();

  return (
    <div role="loading-card">
      <MlpSkeletonWrapper>
        {!isMobile && (
          <SyledLogoWrapper>
            <SalesEventMlpLogo
              sales_event_logo_url_light={sales_event_logo_url_light}
              title={translations.title}
            />
          </SyledLogoWrapper>
        )}
        <StyledBoxeswrapper>
          {isMobile && (
            <SalesEventMlpLogo
              sales_event_logo_url_light={sales_event_logo_url_light}
              title={translations.title}
            />
          )}
          <SkeletonBoxes />
        </StyledBoxeswrapper>
      </MlpSkeletonWrapper>
    </div>
  );
};
